import { AccountResetRequest } from "app/services/api/types/authorisation/requests/AccountResetRequest";
import { Link } from "expo-router";
import { Text } from "react-native";
import { AtomsView } from "ui";
import { Button } from "ui/gluestack/button";
import { FormControlledInput } from "ui/molecules/form/FormControlledInput";
import {
  maxLengthValidation,
  minLengthValidation,
  passwordValidation,
  requiredValidation,
  validationSchema,
} from "ui/utils/Validators";
import { useAccountPasswordSet } from "../hooks/useAccountPasswordSet";
import { LoginPath } from "app/constants/routePaths";
import Card from "../atoms/Card";
import { PasswordSetType } from "../types/PasswordSetType";
import { CardLogo } from "../atoms/CardLogo";
import { View } from "ui/atoms/view";

interface Props {
  type: PasswordSetType;
  email: string;
  token: string;
}
export default function AccountChangePasswordForm({
  type,
  email,
  token,
}: Props) {
  const { control, submitForm, isLoading } = useAccountPasswordSet({
    email,
    token,
    type,
  });

  const title = type === "initial-set" ? "Set password" : "Change password";
  const buttonTitle =
    type === "initial-set" ? "Set password" : "Change password";
  const subtitle = `Create a new password for ${email}`;

  return (
    <AtomsView className="flex-1 justify-center items-center w-full bg-white">
      <Card>
        <CardLogo />
        <View>
          <Text className="font-semibold text-xl mb-2">{title}</Text>
          <Text className="text-xs">{subtitle}</Text>
        </View>
        <FormControlledInput<AccountResetRequest>
          id="reset-password"
          name="password"
          control={control}
          label={"Password"}
          placeholder={"Enter your password"}
          helperText={`Must be at least ${validationSchema.password.minLength} characters.`}
          type="password"
          isRequired
          rules={{
            maxLength: maxLengthValidation(validationSchema.password.maxLength),
            minLength: minLengthValidation(validationSchema.password.minLength),
            required: requiredValidation("Password"),
            validate: {
              passwordValidation,
            },
          }}
          isDisabled={isLoading}
          onSubmitEditing={submitForm}
        />
        <FormControlledInput<AccountResetRequest>
          id="reset-password-confirm"
          name="password_confirmation"
          control={control}
          label={"Confirm Password"}
          placeholder={"Confirm your password"}
          type="password"
          isRequired
          rules={{
            required: requiredValidation("Confirm Password"),
            maxLength: maxLengthValidation(validationSchema.password.maxLength),
            minLength: minLengthValidation(validationSchema.password.minLength),
            validate: {
              matches: (value: string, fields) => {
                return (
                  value === fields.password ||
                  "Confirmation password does not match your password"
                );
              },
            },
          }}
          isDisabled={isLoading}
          onSubmitEditing={submitForm}
        />
        <Button onPress={submitForm} action="primary" isDisabled={isLoading}>
          <Text className="text-white">{buttonTitle}</Text>
        </Button>
        <Link className="self-center h-8 justify-center" href={LoginPath}>
          <Text className="text-typography-500 hover:underline">
            Back to Log in
          </Text>
        </Link>
      </Card>
    </AtomsView>
  );
}
